import { ref, watch, type WatchSource } from 'vue'

/** Keep the first slide in SSR HTML; prepare neighbours only after it loads or the user swipes. */
export const useSwipeImageLoading = (slides: WatchSource<readonly unknown[]>) => {
  const activeImage = ref(0)
  const preparedImages = ref(new Set([0]))
  let count = 0

  const prepareImages = (index: number) => {
    if (!count) return
    const current = ((index % count) + count) % count
    activeImage.value = current
    for (const candidate of [current, (current + 1) % count, (current + count - 1) % count]) {
      preparedImages.value.add(candidate)
    }
  }

  watch(slides, items => {
    count = items.length
    // Vant retains its current slide when same-length CMS/gallery data changes.
    // Reset visited URLs, but keep that visible slide prepared as well as index 0
    // for callers that explicitly return to the first slide after a SKU change.
    activeImage.value = Math.max(0, Math.min(activeImage.value, count - 1))
    preparedImages.value = new Set([0, activeImage.value])
  }, { immediate: true, deep: true })

  const onImageLoad = (index: number) => {
    if (index === activeImage.value) prepareImages(index)
  }

  return { activeImage, preparedImages, prepareImages, onImageLoad }
}
